import { Pipe, PipeTransform } from '@angular/core';
import { HelperManager } from '../managers/helper.manager';

/*
 * Formats decimal with comma as decimal separator and point for thousands separator
 * Usage:
 *   value | asFormatDecimal
 * Example:
 *   {{ 64654.56 |  asFormatDecimal}}
 *   formats to: 64.654,56
 */
@Pipe({ name: 'asFormatDecimal' })
export class FormatDecimal implements PipeTransform {
  constructor(public helperManager: HelperManager) {}

  transform(
    value: number | string,
    addDefaultDecimals?: boolean,
    precision?: number,
    increasePrecisionToFirstNonZero?: boolean
  ): string {
    if (value || value === 0) {
      // input is 100,59 -> transform to 100.59
      // const valueToTransform = precision && typeof value === 'number' ? parseFloat(value.toString().replace(/\,/g, ".")).toFixed(precision) : value;
      let precisionToFormat = precision;
      if (increasePrecisionToFirstNonZero) {
        precisionToFormat = Math.max(
          this.helperManager.getFirstNonZeroDecimalIndex(value.toString()) + 1,
          precision
        );
      }
      return this.helperManager.formatDecimal(
        value.toString(),
        addDefaultDecimals,
        precisionToFormat
      );
    } else {
      return !value ? '' : value.toString();
    }
  }

  parse(value: string): string {
    if (value) {
      // return this.helperManager.formatDecimal(value.toString());
      return value
        .replace(/\./g, '')
        .replace(/[,](?=.*[,])/g, '') // replace all comma's except last one --> 5,000,50 should be 5000,50
        .trim(); // replace decimal point character with ''
    }
  }
}
